import React from "react";
import Select from "react-select";
import { HUMAN_TIMEZONES } from "../../constants";

const TimezoneSelect = ({ 
  label, 
  id, 
  name, 
  value, 
  onChange, 
  onBlur, 
  error, 
  required, 
  ...rest 
}) => {
  const options = Object.entries(HUMAN_TIMEZONES).map(([label, value]) => ({
    label: label,
    value: label
  }));

  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name: name,
        value: selectedOption?.value || ""
      }
    });
  };

  const selectedValue = options.find(option => option.value === value);

  return (
    <div className="custom-form-group">
      <label htmlFor={id}>{label}</label>
      
      <Select
        inputId={id}
        name={name}
        options={options}
        value={selectedValue}
        onChange={handleChange}
        onBlur={onBlur}
        required={required}
        isSearchable={true}  // Enable search functionality
        filterOption={(option, inputValue) => {
          // Custom search that matches both timezone name and GMT offset
          const searchStr = inputValue.toLowerCase();
          return (
            option.label.toLowerCase().includes(searchStr) ||
            option.value.toLowerCase().includes(searchStr)
          );
        }}
        placeholder="Search timezone..."
        className="react-select-container"
        classNamePrefix="react-select"
        styles={{
          control: (provided, state) => ({
            ...provided,
            border: 'none',
            boxShadow: 'none',
            borderRadius: '0',
            minHeight: 'auto',
            marginTop: '36px',
            backgroundColor: 'transparent',
          }),
          valueContainer: (provided) => ({
            ...provided,
            padding: '0 8px',
            backgroundColor: 'transparent'
          }),
          singleValue: (provided) => ({
            ...provided,
            color: '#333'
          }),
          input: (provided) => ({
            ...provided,
            margin: '0',
            padding: '0',
            color: '#333'
          }),
          indicatorSeparator: () => ({
            display: 'none'
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 8px',
            color: '#007CB2',
            '&:hover': {
              color: '#005d8c'
            }
          }),
          menu: (provided) => ({
            ...provided,
            marginTop: '0',
            borderRadius: '0',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            zIndex: 9999
          }),
          menuList: (provided) => ({
            ...provided,
            padding: 0
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#f0f0f0' : 'white',
            color: '#333',
            '&:hover': {
              backgroundColor: '#f5f5f5'
            },
            position: 'relative',
            zIndex: 9999
          }),
          noOptionsMessage: (provided) => ({
            ...provided,
            color: '#666',
            padding: '8px 12px'
          })
        }}
        components={{
          DropdownIndicator: () => null, // Remove default dropdown indicator
          ClearIndicator: () => null    // Remove clear indicator
        }}
        {...rest}
      />

      {error && <div className="error-text">{error}</div>}
      <hr className={error ? "error-hr-line" : ""} />
    </div>
  );
};

export default TimezoneSelect;